import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {PlantPhoto} from './plant-photo';
import {BaseService} from '../common/base.service';

@Injectable({ providedIn: 'root' })
export class PlantPhotoService extends BaseService {
  private apiUrl = this.baseUrl + '/plant-photo';

  searchByPlant(plantId: number): Observable<PlantPhoto[]> {
    const url = `${this.apiUrl}/search/by-plant/${plantId}`;
    return this.http
      .get<PlantPhoto[]>(url)
      .pipe(catchError(this.handleError('Could not find media files by plant', [])));
  }

  getImageBlob(fileName: string): Observable<Blob> {
    const url = `${this.apiUrl}/${fileName}`;
    return this.http
      .get(url, { responseType: 'blob' })
      .pipe();
  }

  uploadPhoto(plantId: number, file: File): Observable<PlantPhoto> {
    const url = `${this.apiUrl}/upload-photo/${plantId}`;
    const formData = new FormData();
    formData.append('file', file, file.name);

    return this.http.post(
      url,
      formData
    ).pipe();
  }
}
